import { set, toggle, __tokenName } from './utils/vuexutils';

export default {
  toggleDrawer: toggle('drawer'),

  setDrawer: (state, value) => {
    state.drawer = value;
  },
  setImage: (state, value) => {
    localStorage.setItem('my_logo_image', value);
    state.image = value;
  },
  setColor: (state, value) => {
    localStorage.setItem('my_selection_color', value);
    state.color = value;
  },

  // SECURITY
  SET_LOGIN_MODAL: (state, dialog) => {
    state.loginModal = dialog;
  },

  SET_CURRENT_USER: (state, user) => {
    if (user == null) {
      user = JSON.parse(localStorage.getItem(__tokenName));
      if (user == null) {
        user = { FullName: '', Spol: '' }
      }
    }

    state.currentUser = user;
  },

  CLEAR_CURRENT_USER_NAME: (state) => {
    state.currentUser.Name = '';
    state.currentUser.Surname = '';
    state.currentUser.FullName = '';

  },


  
 
  SET_PODRUZNICE: (state, { data, force }) => {
    if (typeof state.podruznice === 'undefined' || state.podruznice.length == 0 || force) {
      state.podruznice = data;
    }
  }

}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/app/app_mutations.js